import { render } from "./SiteFooter.vue?vue&type=template&id=792c623e&scoped=true"
const script = {}

import "./SiteFooter.vue?vue&type=style&index=0&id=792c623e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-792c623e"]])

export default __exports__